import { defineStore } from 'pinia'
import { useAuthStore } from './useAuthStore'
import { cmsStore } from './cmsStore'

export const useStreakStore = defineStore('streakStore', {
    state: () => ({
      weekStreaks: [],
      totalStreak: 0,
      streakEndsAt: '',
    }),
    getters: {
      getWeekStreaks() {
        return this.weekStreaks
      },
      getTotalStreak() {
        return this.totalStreak
      },
      getStreakEndsAt() {
        return this.streakEndsAt
      },
    },
    actions: {
      async requestClaimStreak() {
        const path = `/api/streak/claim`
        const response = await $fetch(path, {
          method: 'POST',
          credentials: 'include',
        })
        if (!response) {
          console.error(`Error fetching ${collection}:`, error.value)
        }
        return response
      },
      async requestCheckResetStreak() {
        const path = `/api/streak/check-reset`
        const response = await $fetch(path, {
          method: 'POST',
          credentials: 'include',
        })
        if (!response) {
          console.error(`Error fetching ${collection}:`, error.value)
        }
        return response
      },
      async getUserStreaks() {
        const auth = useAuthStore()
        if (!auth.isAuthenticated) {
          return
        }
        const userId = auth.user.directusUser.id
        const path = `/api/streak/list/${userId}`
        const response = await $fetch(path, {
          method: 'GET',
          credentials: 'include',
        })
        if (!response) {
          console.error(`Error fetching ${collection}:`, error.value)
        }
        console.log(response)
        this.weekStreaks = this.addOpacityToWeekStreaks(response.weekStreaks)
        this.totalStreak = response.totalStreak
        this.streakEndsAt = response.streakEndsAt
      },
      addOpacityToWeekStreaks(data) {
        let firstFalseFound = false
        data.forEach(item => {
          if (item.claimed === false) {
            if (!firstFalseFound) {
                item.opacity = false
                firstFalseFound = true
            } else {
                item.opacity = true
            }
          }
          else {
            item.opacity = false
          }
        })
        return data
      },
    },
})
